export default {
  SET_BANKS (state, payload) {
    state.selects.banks = payload;
  },
};
